'use client';

type ScrollDownProps = {
  text: string;
};

import Classes from './style.module.scss';

import UnstyledLink from '../links/UnstyledLink';

export default function ScrollDown(props: ScrollDownProps) {
  const { text } = props;

  return (
    <UnstyledLink
      href='#section-highlights'
      className='flex w-min items-center gap-6 hover:underline'
      scrollToAnchor
    >
      <svg
        className='pointer-events-none'
        width='26'
        height='33'
        viewBox='0 0 22 33'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          x='1'
          y='1'
          width='22'
          height='31'
          rx='10'
          stroke='#ffffff'
          strokeWidth='1'
        ></rect>
        <rect
          className={Classes.scrollIconDot}
          x='11.0022'
          y='8'
          width='2'
          height='6.66667'
          rx='1'
          fill='#ffffff'
        ></rect>
      </svg>
      <span className='pointer-events-none block whitespace-nowrap text-nowrap'>
        {text}
      </span>
    </UnstyledLink>
  );
}
